const initState = {
    accountFinancialPayers: {},
};

const SET_ACCOUNT_FINANCIAL = 'SET_ACCOUNT_FINANCIAL';

export const setAccountFinancialInfo = (data) => ({ type: SET_ACCOUNT_FINANCIAL, payload: data });

export default (state = initState, action) => {
    switch (action.type) {
        case SET_ACCOUNT_FINANCIAL:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
